<template>
  <v-app id="inspire">
    <v-app-bar
      fixed
      :color="this.$vuetify.theme.themes.light.barraSuperior"
      :class="this.$vuetify.theme.themes.light.barraText"
      app
    >
      <v-app-bar-nav-icon class="ml-2" v-if="$mostraLogoBarra == 'TRUE'">
        <v-img
          height="40"
          :src="`logo-pequeno.png`"
          :lazy-src="`logo-pequeno.png`"
          contain
        >
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-icon
          v-if="$mostraTempoBarra"
          :class="this.$vuetify.theme.themes.light.barraText"
          >mdi-clock-outline</v-icon
        >
        <v-chip
          v-if="$mostraTempoBarra"
          color="transparent"
          class="mt-4"
          :class="this.$vuetify.theme.themes.light.barraText"
          >{{ segundosLabel }}</v-chip
        >
        <v-btn
          v-if="$mostraBotaoVagas == 'TRUE'"
          text
          @click="vagas"
          :class="this.$vuetify.theme.themes.light.barraText"
        >
          <v-icon left>mdi-briefcase-search</v-icon>Vagas
        </v-btn>
        <v-btn
          text
          @click="dialog = true"
          :class="this.$vuetify.theme.themes.light.barraText"
        >
          <v-icon left>mdi-lock-question</v-icon>Alterar senha
        </v-btn>
        <v-btn
          text
          @click="logout"
          :class="this.$vuetify.theme.themes.light.barraText"
        >
          <v-icon left>mdi-exit-to-app</v-icon>Sair
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-main app>
      <v-container fluid grid-list-md class="mt-5">
        <v-layout row wrap justify-center align-center>
          <v-flex xs12 lg8>
            <v-stepper v-model="e6" vertical class="text-left">
              <v-stepper-step :complete="e6 > 1" step="1"
                >Dados pessoais</v-stepper-step
              >

              <v-stepper-content step="1" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form ref="formPessoa" v-model="valid" lazy-validation>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              disabled
                              return-masked-value
                              v-model="pessoa.cpf"
                              label="CPF"
                              :rules="[(v) => !!v || 'Preencha o CPF']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              :rules="nomeRules"
                              v-model="pessoa.nome"
                              label="Nome"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg8>
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  dense
                                  v-model="pessoa.dtnascimento"
                                  v-mask="maskData"
                                  label="Nascimento"
                                  persistent-hint
                                  v-on="on"
                                  :rules="[
                                    nascimentoRules.required,
                                    nascimentoRules.dataAtual,
                                  ]"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="date1"
                                no-title
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 lg4>
                            <v-radio-group v-model="pessoa.sexo" row>
                              Sexo:
                              <v-radio
                                color="primary"
                                label="Feminino"
                                :value="false"
                              ></v-radio>
                              <v-radio
                                color="primary"
                                label="Masculino"
                                :value="true"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              dense
                              v-model="pessoa.nomePai"
                              label="Nome do Pai"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              dense
                              v-model="pessoa.nomeMae"
                              label="Nome da Mãe"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              :rules="emailRules"
                              v-model="pessoa.email"
                              label="Email"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              dense
                              @blur="getCidadeCEP"
                              v-mask="maskCep"
                              return-masked-value
                              v-model="pessoa.codcep"
                              :rules="cepRules"
                              label="CEP"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg10>
                            <v-text-field
                              dense
                              v-model="pessoa.endereco"
                              :rules="enderecoRules"
                              label="Endereço"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg2>
                            <v-text-field
                              dense
                              v-model="pessoa.numero"
                              type="number"
                              :rules="numeroRules"
                              label="Número"
                              min="0"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg5>
                            <v-text-field
                              dense
                              v-model="pessoa.bairro"
                              :rules="bairroRules"
                              label="Bairro"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg5>
                            <v-text-field
                              dense
                              v-model="pessoa.cidade"
                              :rules="cidadeRules"
                              disabled
                              label="Cidade"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg2>
                            <v-text-field
                              dense
                              v-model="pessoa.uf"
                              label="UF"
                              disabled
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="pessoa.fone"
                              label="Telefone"
                              v-mask="maskCel"
                              return-masked-value
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="pessoa.celular"
                              v-mask="maskCel"
                              return-masked-value
                              :rules="celularRules"
                              label="Celular"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-select
                              dense
                              v-model="pessoa.codestadocivil"
                              :items="estadosCivil"
                              label="Estado civil"
                              item-value="codEstadoCivil"
                              item-text="descricao"
                              :rules="[(v) => !!v || 'Preencha o Estado Civil']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 lg8>
                            <v-select
                              dense
                              v-model="pessoa.codgrau"
                              :items="instrucoes"
                              label="Grau de instrução"
                              item-value="codGrau"
                              item-text="descricao"
                              :rules="[
                                (v) => !!v || 'Preencha o Grau de Instrução',
                              ]"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 lg4>
                            <v-text-field
                              dense
                              v-model="pessoa.rg"
                              label="RG"
                              :rules="rgRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg4>
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  dense
                                  v-model="pessoa.dtEmissaoRg"
                                  label="Emissão RG"
                                  v-mask="maskData"
                                  persistent-hint
                                  v-on="on"
                                  :rules="dataValidaRules"
                                  :error-messages="erroMensagemEmissaoRG"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="date2"
                                no-title
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 lg4>
                            <v-text-field
                              dense
                              v-model="pessoa.orgaoRG"
                              label="Orgão expedidor RG"
                              required
                            ></v-text-field>
                          </v-flex>
                          <template v-if="$mostrarDadosCNH">
                            <v-flex xs12 lg4>
                              <v-text-field
                                dense
                                v-model="pessoa.cnh"
                                v-mask="maskCnh"
                                label="CNH"
                                :maxlength="11"
                                return-masked-value
                                :disabled="pessoa.codpessoa > 0"
                                required
                                :rules="cnhRules"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4>
                              <v-select
                                dense
                                v-model="pessoa.categoriaCnh"
                                :items="categorias"
                                label="Categoria"
                                :disabled="pessoa.codpessoa > 0"
                                :rules="cnhRules"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4>
                              <v-menu
                                ref="menu3"
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    dense
                                    v-model="pessoa.dtValidadeCNH"
                                    label="Validade CNH"
                                    persistent-hint
                                    v-mask="maskData"
                                    v-on="on"
                                    :rules="cnhRules"
                                    :disabled="pessoa.codpessoa > 0"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="date3"
                                  no-title
                                  @input="menu3 = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                          </template>

                          <v-flex xs12 lg6>
                            <v-select
                              dense
                              v-model="pessoa.codCidadeTrabalhar"
                              :items="cidades"
                              item-value="codCidade"
                              :rules="[(v) => !!v || 'Preencha a Cidade']"
                              item-text="nome"
                              label="Cidade onde deseja trabalhar"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="pessoa.vlrSalPretendido"
                              label="Pretensão salarial"
                              v-cgi-number
                              :rules="pretensaoRules"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 lg6>
                            <v-select
                              dense
                              v-model="pessoa.codCargoPretendido"
                              :items="cargos"
                              item-value="codCargo"
                              :rules="regraDeInteiro"
                              item-text="descricao"
                              label="Cargo Pretendido"
                              required
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 lg6>
                            <v-text-field
                              v-if="pessoa.codCargoPretendido == 0"
                              dense
                              v-model="pessoa.cargoPretendido"
                              type="text"
                              label="Descrição do cargo pretendido"
                              :rules="[
                                (v) => !!v || 'Escreva o Cargo Pretendido',
                              ]"
                              required
                            >
                            </v-text-field>
                          </v-flex>

                          <v-flex xs4>
                            Disponibilidade para viagens
                            <v-switch
                              color="primary"
                              v-model="pessoa.dispviagem"
                              :label="pessoa.dispviagem ? 'Sim' : 'Não'"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs4>
                            Disponibilidade para mudança de domicilio
                            <v-switch
                              color="primary"
                              v-model="pessoa.dispMudanca"
                              :label="pessoa.dispMudanca ? 'Sim' : 'Não'"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs4>
                            Portador de necessidades especiais
                            <v-switch
                              color="primary"
                              v-model="pessoa.deficienteFisico"
                              :label="pessoa.deficienteFisico ? 'Sim' : 'Não'"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs4>
                            Disponibilidade para trabalhar em regime de turnos
                            <v-switch
                              color="primary"
                              v-model="pessoa.regimeTurnos"
                              :label="pessoa.regimeTurnos ? 'Sim' : 'Não'"
                            ></v-switch>
                          </v-flex>
                          <v-flex xs4>
                            Disponibilidade para trabalhar aos sabados ou
                            domingos em revezamento
                            <v-switch
                              color="primary"
                              v-model="pessoa.revezamento"
                              :label="pessoa.revezamento ? 'Sim' : 'Não'"
                            ></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn
                  color="primary"
                  :loading="loading"
                  :disabled="loading ? true : false"
                  @click="gravaDadosPessoais"
                  >Próximo</v-btn
                >
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" step="2"
                >Áreas de interesse</v-stepper-step
              >

              <v-stepper-content step="2" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form
                        ref="formAreaInteresse"
                        v-model="valid"
                        lazy-validation
                      >
                        <v-layout row wrap v-for="(area, i) in areas" :key="i">
                          <v-flex xs12>
                            <v-select
                              dense
                              v-model="area.codAreaInteresse"
                              :items="areaJson"
                              item-value="codAreaInteresse"
                              item-text="descricao"
                              label="Área de interesse"
                              :rules="areaInteresseRules"
                              required
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <div class="text-xs-right">
                          <v-btn fab @click="addArea">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 1">Anterior</v-btn>
                <v-btn color="primary" @click="gravaAreasInteresse"
                  >Próximo</v-btn
                >
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 3" step="3"
                >Formação acadêmica</v-stepper-step
              >

              <v-stepper-content step="3" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form
                        ref="formFormacaoAcademica"
                        v-model="valid"
                        lazy-validation
                      >
                        <v-layout
                          row
                          wrap
                          v-for="(formacao, i) in formacoes"
                          :key="i"
                        >
                          <v-flex xs12 lg6>
                            <v-select
                              dense
                              v-model="formacao.codEducacao"
                              :items="formacoesJson"
                              item-value="codEducacao"
                              item-text="descricao"
                              label="Formação"
                              :rules="formacaoRules"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="formacao.habilitacao"
                              label="Curso"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="formacao.instituicao"
                              label="Instituição"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              return-masked-value
                              v-mask="maskData"
                              v-model="formacao.dtConclusao"
                              label="Conclusão"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <div class="text-xs-right">
                          <v-btn fab @click="addFormacao">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 2">Anterior</v-btn>
                <v-btn color="primary" @click="gravaFormacaoAcademica"
                  >Próximo</v-btn
                >
              </v-stepper-content>

              <v-stepper-step step="4" :complete="e6 > 4"
                >Histórico profissional</v-stepper-step
              >

              <v-stepper-content step="4" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form
                        ref="formProfissional"
                        v-model="valid"
                        lazy-validation
                      >
                        <v-layout
                          row
                          wrap
                          v-for="(historico, i) in historicos"
                          :key="i"
                        >
                          <v-flex xs12>
                            <v-text-field
                              dense
                              v-model="historico.empresaAnterior"
                              label="Empresa"
                              :rules="historicoRules"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="historico.cargoInicial"
                              label="Cargo inicial"
                              :rules="historicoCargoIniRules"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="historico.cargoFinal"
                              label="Cargo final"
                              :rules="historicoCargoFimRules"                              
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-cgi-number
                              v-model="historico.salarioInicial"
                              label="Remuneração Inicial (R$)"
                              :rules="historicoRemunIniRules"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-cgi-number
                              v-model="historico.salarioFinal"
                              label="Remuneração Final (R$)"
                              :rules="historicoRemunFimRules"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="historico.dtEntrada"
                              return-masked-value
                              v-mask="maskData"
                              label="Entrada"
                              :rules="historicoDtEntradaRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="historico.dtSaida"
                              return-masked-value
                              v-mask="maskData"
                              label="Saída"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 lg6>
                            <v-text-field
                              dense
                              v-model="historico.ramoAtividade"
                              label="Ramo Atividade"
                              :rules="historicoRamoRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="historico.atribuicoes"
                              label="Atribuições"
                              :rules="historicoAtribuicoesRules"
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              v-model="historico.motivosaida"
                              label="Motivo Saída"
                            ></v-textarea>
                          </v-flex>
                          <v-divider></v-divider>
                        </v-layout>
                        <div class="text-xs-right">
                          <v-btn fab @click="addHistorico">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 3">Anterior</v-btn>
                <v-btn color="primary" @click="gravaHistoricoProfissional"
                  >Próximo</v-btn
                >
              </v-stepper-content>

              <v-stepper-step step="5" :complete="e6 > 5"
                >Indicação</v-stepper-step
              >

              <v-stepper-content step="5" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout
                          row
                          wrap
                          v-for="(pessoa, i) in indicacoes"
                          :key="i"
                        >
                          <v-flex xs6>
                            <v-text-field
                              dense
                              v-model="pessoa.nome"
                              label="Nome"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              dense
                              v-model="pessoa.telefone"
                              label="Telefone"
                              v-mask="maskCel"
                              return-masked-value
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox
                              dense
                              v-model="pessoa.vip"
                              label="É funcionário da empresa"
                              color="primary"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <div class="text-xs-right">
                          <v-btn fab @click="addPessoa">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 4">Anterior</v-btn>
                <v-btn color="primary" @click="gravaPessoaReferencia"
                  >Proximo</v-btn
                >
              </v-stepper-content>

              <v-stepper-step step="6" :complete="e6 > 6"
                >Idiomas</v-stepper-step
              >

              <v-stepper-content step="6" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout
                          row
                          wrap
                          v-for="(idioma, i) in idiomas"
                          :key="i"
                        >
                          <v-select
                            dense
                            v-model="idioma.codidioma"
                            :items="idiomasJson"
                            item-value="codidioma"
                            item-text="descricao"
                            label="Idiomas"
                            required
                          ></v-select>
                          <v-flex xs2>
                            <v-checkbox
                              v-model="idioma.le"
                              label="Lê"
                              color="primary"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-checkbox
                              v-model="idioma.fala"
                              label="Fala"
                              color="primary"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-checkbox
                              v-model="idioma.escreve"
                              label="Escreve"
                              color="primary"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <div class="text-xs-right">
                          <v-btn fab @click="addIdioma">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 5">Anterior</v-btn>
                <v-btn color="primary" @click="gravaIdioma">Proximo</v-btn>
              </v-stepper-content>

              <v-stepper-step step="7" :complete="e6 > 7"
                >Anexos</v-stepper-step
              >

              <v-stepper-content step="7" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col :cols="($codEmp && $codEmp == codEmpPicaPau) ? '6' : '12'" class="pt-0 pb-2">
                            <div class="d-flex">
                              <v-file-input
                                v-model="imagem"
                                chips
                                show-size
                                label="Foto Pessoal (arquivos com extensão JPG, JPEG ou PNG)"
                                filled
                              >
                              </v-file-input>
                              <v-tooltip v-model="showTooltipImagem" top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div class="pt-3">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                      <v-icon color="grey lighten-1">
                                        mdi-information
                                      </v-icon>
                                    </v-btn>
                                  </div>
                                </template>
                                <span>Sua foto de perfil é uma parte crucial do seu currículo. Deve-se seguir estas diretrizes ao garantir a segurança de sua foto: Rosto visível e dominante. Fundo neutro (preferencialmente sólido). Vestimenta sóbria e profissional. Evite filtros exagerados.</span>
                              </v-tooltip>
                            </div>
                          </v-col>
                          <v-col cols="6" class="pt-0 pb-2" v-if="$codEmp && $codEmp == codEmpPicaPau || $codEmp == codEmpJan || $codEmp == codEmpAgroaraca || $codEmp == codEmpSanterra || $codEmp == codEmpAgrosys || $codEmp == codEmpRazera">
                            <div class="d-flex">
                              <v-file-input
                                v-model="arquivoCurriculo"
                                chips
                                show-size
                                label="Currículo"
                                filled
                              >
                              </v-file-input>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div class="pt-3">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                      <v-icon color="grey lighten-1">
                                        mdi-information
                                      </v-icon>
                                    </v-btn>
                                  </div>
                                </template>
                                <span>Anexo de um currículo no formato de arquivo</span>
                              </v-tooltip>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 6">Anterior</v-btn>
                <v-btn color="primary" @click="gravaAnexo">Finalizar</v-btn>
              </v-stepper-content>

              <v-stepper-step step="8" :complete="e6 > 8"
                >Finalização</v-stepper-step
              >

              <v-stepper-content step="8" class="text-xs-left">
                <div class="pa-2">
                  <v-card class="mb-5 pa-2">
                    <v-card-text>
                      <v-layout row wrap justify-centeralign-center
                        >Muito obrigado, entraremos em contato</v-layout
                      >
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn text @click="e6 = 7">Anterior</v-btn>
                <v-btn color="primary" @click="e6 = 1">Revisar</v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar class="headline grey lighten-2" flat dense>
            Trocar senha!
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-text-field
            dense
            type="password"
            v-model="pessoa.senha"
            label="Nova senha"
            required
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false">fechar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="alteraSenha">Trocar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErro" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Ops!</v-card-title
        >

        <v-card-text class="pa-2">
          <span style="white-space: pre">{{ dialogMessage }}</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="(dialogErro = false), (dialogMessage = '')"
            >fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogLGPD" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 text-center" primary-title>
          <v-spacer></v-spacer>
          Termos de uso!
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="pa-2">
          <span style="white-space: pre"
            >Por favor, aceite nossos
            <a target="_blank" :href="urltermo">termos de uso</a> antes de
            continuar</span
          >
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn block color="primary" text @click="aceitar">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="8000"
      :vertical="false"
    >
      {{ mensagem }}
      <v-btn :color="snackbarColor" text @click="snackbar = false">OK</v-btn>
    </v-snackbar>
    <cgi-footer />
  </v-app>
</template>

<script>
import Service from "@/services/service.js";
import Categorias from "@/services/const.js";
import moment from "moment";
import LoginVue from "./Login.vue";
import Footer from "./Footer.vue";
import VagasEmpregoVue from "./VagasEmprego.vue";
export default {
  components: {
    "cgi-footer": Footer,
  },
  data: (vm) => ({
    urltermo: null,
    dialogLGPD: false,
    mensagem: "",
    snackbar: false,
    snackbarColor: "red",
    dialog: false,
    dialogErro: false,
    dialogMessage: "",
    erroExtensao: false,

    //Mascaras
    maskData: "##/##/####",
    maskCel: "(##)#####-####",
    maskCep: "#####-###",
    maskCnh: "###########",

    //Regras de Validação
    bairroRules: [(v) => !!v || "Preencha o bairro"],
    cepRules: [
      (v) => !!v || "Preencha o CEP",
      (v) => (v && v.length >= 9) || "CEP inválido",
    ],
    cidadeRules: [(v) => !!v || "Preencha a cidade"],
    cnhRules: [
      (v) =>
        vm.validaCNH(v) ||
        "Preencha completamente as informações referente a CNH.",
      (v) => vm.validaObrigatorioCNH(v) || "CNH Obrigatório",
    ],
    dataValidaRules: [(v) => vm.dataValida(v) || "Data inválida."],
    enderecoRules: [(v) => !!v || "Preencha o endereço"],
    nascimentoRules: {
      required: (v) => !!v || "Preencha a data de nascimento",
      dataAtual: (v) =>
        vm.validacaoDataAtual(v) ||
        "A data de nascimento não pode ser superior a data atual",
      dataValida: (v) => vm.dataValida(v) || "Data inválida.",
    },
    nomeRules: [(v) => !!v || "Preencha o nome"],
    numeroRules: [(v) => !!v || "Preencha o número"],
    pretensaoRules: [(v) => vm.validaPretensao(v) || "Preencha a pretensão salarial."],
    rgRules: [(v) => vm.validaRG(v) || "Preencha o RG."],
    celularRules: [(v) => vm.validaCelular(v) || "Preencha o Celular."],
    emailRules: [(v) => vm.validaEmail(v) || "Preencha o E-mail."],
    regraDeInteiro: [
      (v) => {
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 99999999999) return true;
        return "Preencha o campo";
      },
    ],
    historicoRules: [(v) => vm.validaHistoricoEmpresa(v) || "Preencha o nome da empresa."],
    historicoCargoIniRules: [(v) => vm.validaHistorico(v) || "Preencha o cargo ocupado inicialmente."],
    historicoCargoFimRules: [(v) => vm.validaHistorico(v) || "Preencha o cargo ocupado no desligamento."],
    historicoRemunIniRules: [(v) => vm.validaHistorico(v) || "Preencha a remuneração inicial."],
    historicoRemunFimRules: [(v) => vm.validaHistorico(v) || "Preencha a remuneração Final."],
    historicoDtEntradaRules: [(v) => vm.validaHistorico(v) || "Preencha a data de Entrada."],
    historicoAtribuicoesRules: [(v) => vm.validaHistorico(v) || "Preencha as atribuições."],
    historicoRamoRules: [(v) => vm.validaHistorico(v) || "Preencha o ramo de atividade da empresa."],
    areaInteresseRules: [(v) => vm.validaArea(v) || "Informe ao menos uma area de Interesse."],
    formacaoRules: [(v) => vm.validaFormacao(v) || "Para o Grau de Instruçao informado, deve ser informado formação."],
    erroMensagemEmissaoRG: null,
    areas: [
      {
        codcandidato: null,
        codAreaInteresse: null,
        descricao: null,
      },
    ],
    areaJson: [],
    service: new Service(),
    print: console.log,
    valid: false,
    e6: 1,
    value: 40,
    senha: null,
    confirmaSenha: null,
    categorias: Categorias.categoriasCNH,
    imagem: null,
    showTooltipImagem: false,
    estadosCivil: [],
    instrucoes: [],
    cidades: [],
    cargos: [],
    codIbge: null,

    idiomas: [
      {
        codPessoa: 0,
        codidioma: 0,
        le: false,
        fala: false,
        escreve: false,
      },
    ],
    formacoes: [
      {
        codEducacao: 0,
        habilitacao: "",
        instituicao: "",
        dtConclusao: "",
        codpessoa: 0,
      },
    ],
    historicos: [
      {
        codpessoa: null,
        empresaAnterior: null,
        cargoInicial: null,
        cargoFinal: null,
        salarioInicial: "",
        salarioFinal: "",
        dtEntrada: null,
        dtSaida: null,
        atribuicoes: null,
        motivosaida: null,
        ramoAtividade: null,
      },
    ],
    indicacoes: [
      {
        codCandidato: 0,
        nome: "",
        telefone: "",
        vip: false
      },
    ],
    pessoa: {
      codpessoa: 0,
      cpf: "",
      nome: "",
      email: "",
      dtnascimento: "",
      codestadocivil: 0,
      celular: "",
      fone: "",
      endereco: "",
      numero: 0,
      bairro: "",
      cidade: "",
      sexo: true,
      uf: "",
      dispviagem: false,
      dispMudanca: false,
      vlrSalPretendido: "0.00",
      regimeTurnos: false,
      revezamento: false,
      pretensao: "",
      codcep: 0,
      codCidadeTrabalhar: 0,
      codCargoPretendido: 0,
      cargoPretendido: "",
      codgrau: 0,
      rg: "",
      dtEmissaoRg: "",
      orgaoRG: "",
      cnh: "",
      categoriaCnh: "",
      orgaoCNH: "",
      dtValidadeCNH: "",
      senha: "",
      codibge: 0,
      deficienteFisico: false,
      nomePai: "",
      nomeMae: "",
    },
    formacoesJson: [],
    date1: new Date().toISOString().substr(0, 10),
    menu1: false,
    date2: new Date().toISOString().substr(0, 10),
    menu2: false,
    date3: new Date().toISOString().substr(0, 10),
    menu3: false,
    date4: new Date().toISOString().substr(0, 10),
    menu4: false,
    erroCep: "",
    idiomasJson: [],
    segundos: parseInt(vm.$segundosSessao),
    segundosLabel: null,
    loading: false,
    arquivoCurriculo: null,
    codEmpPicaPau: 5783,
    codEmpJan: 181,
    codEmpAgroaraca: 5641,
    codEmpSanterra: 5823,
    codEmpAgrosys: 5047,
    codEmpRazera: 229,
    parametros: [],
    empresaAnteriorValida: "",
  }),
  watch: {
    date1() {
      this.pessoa.dtnascimento = this.formatDate(this.date1);
    },
    date2() {
      this.pessoa.dtEmissaoRg = this.formatDate(this.date2);
    },
    date3() {
      this.pessoa.dtValidadeCNH = this.formatDate(this.date3);
    },
    pessoa: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
    areas: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
    formacoes: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
    historicos: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
    indicacoes: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
    idiomas: {
      handler() {
        this.resetarTimer();
      },
      deep: true,
    },
  },
  async mounted() {
    let formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    if (localStorage.getItem("logado") === null) {
      localStorage.setItem("logado", moment().format("DD/MM/YYYY HH:mm:ss"));
    }

    this.segundos = parseInt(this.$segundosSessao);

    if (
      localStorage.getItem("logado") === null ||
      moment().diff(
        moment(localStorage.getItem("logado"), "DD/MM/YYYY HH:mm:ss"),
        "minutes"
      ) > 60
    ) {
      this.logout();
    }

    this.timer();
    var response;

    response = await this.service.getParamCurriculo();
    this.parametros = response.data.ttParamCurriculo;

    response = await this.service.getCidadesTrabalho();
    this.cidades = response.data.ttCidadeTrabalhar;

    response = await this.service.getEducacao();
    this.formacoesJson = response.data.ttEducacao;

    response = await this.service.getGrauEstrucao();
    this.instrucoes = response.data.ttGrauinstrucao;

    response = await this.service.getEstadoCivil();
    this.estadosCivil = response.data.ttEstadocivil;

    response = await this.service.getAreaInteresse();
    this.areaJson = response.data.ttAreaInteresse;

    response = await this.service.buscaPessoa();
    if (response.data.ttPessoa !== undefined) {
      response.data.ttPessoa[0].dtnascimento = this.formatDate(
        response.data.ttPessoa[0].dtnascimento
      );
      response.data.ttPessoa[0].dtEmissaoRg = this.formatDate(
        response.data.ttPessoa[0].dtEmissaoRg
      );

      response.data.ttPessoa[0].dtValidadeCNH = this.formatDate(
        response.data.ttPessoa[0].dtValidadeCNH
      );
      //aqui
      // response.data.ttPessoa[0].sexo = response.data.ttPessoa[0].sexo;
      this.pessoa = response.data.ttPessoa[0];

      this.pessoa.vlrSalPretendido = formatter.format(
        this.pessoa.vlrSalPretendido
      );
    }

    this.pessoa.cpf = localStorage.getItem("cpf");
    this.pessoa.senha = localStorage.getItem("senha");
    this.pessoa.codpessoa = parseInt(localStorage.getItem("codPessoa"));

    response = await this.service.buscaHistorico();

    this.historicos = [];
    let historicoBranco = [];

    if (response.data.ttHistoricoProfissional !== undefined) {
      for (let h of response.data.ttHistoricoProfissional) {
        h.dtEntrada = this.formatDate(h.dtEntrada);
        h.dtSaida = this.formatDate(h.dtSaida);
        h.salarioInicial = formatter.format(h.salarioInicial);
        h.salarioFinal = formatter.format(h.salarioFinal);
      }

      if (response.data.ttHistoricoProfissional.length > 0) {
        this.historicos = response.data.ttHistoricoProfissional.concat(
          this.historicos
        );
      } else {
        if (historicoBranco < 2) {
          historicoBranco.push({
            codpessoa: null,
            empresaAnterior: null,
            cargoInicial: null,
            cargoFinal: null,
            salarioInicial: "",
            salarioFinal: "",
            dtEntrada: null,
            dtSaida: null,
            atribuicoes: null,
            motivosaida: null,
            ramoAtividade: null,
          });
        }

        for (let h of historicoBranco) {
          h.dtEntrada = this.formatDate(h.dtEntrada);
          h.dtSaida = this.formatDate(h.dtSaida);
          h.salarioInicial = formatter.format("0.00");
          h.salarioFinal = formatter.format("0.00");
        }

      }
    }
    this.historicos = historicoBranco.concat(this.historicos);

    response = await this.service.buscaIndicacoes();

    if (response.data.ttIndicacao) {
      this.indicacoes = response.data.ttIndicacao.concat(this.indicacoes);
    }

    response = await this.service.buscaAreas();

    if (response.data.ttAreaInteresseCandidato) {
      this.areas = response.data.ttAreaInteresseCandidato.concat(this.areas);
    }

    response = await this.service.buscaIdioma();

    if (response.data.ttIdiomaPessoa) {
      this.idiomas = response.data.ttIdiomaPessoa.concat(this.idiomas);
    }

    response = await this.service.buscaFormacao();

    if (response.data.ttFormacao) {
      for (let f of response.data.ttFormacao) {
        f.dtConclusao = this.formatDate(f.dtConclusao);
      }

      this.formacoes = response.data.ttFormacao.concat(this.formacoes);
    }

    response = await this.service.getIdiomas();

    this.idiomasJson = response.data.ttIdioma;

    response = await this.service.getCargosTrabalho();
    this.cargos = response?.data?.ttCargo ?? [];
    const outro = {
      codCargo: 0,
      descricao: "OUTRO - PREENCHER A DESCRIÇÃO",
    };
    this.cargos.push(outro);

    this.cargos.sort(function (a, b) {
      return a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0;
    });
  },
  methods: {
    timer() {
      if (localStorage.getItem("logado") === null) {
        this.logout();
      } else {
        setTimeout(() => {
          if (this.segundos > 0) {
            let segundosFormatados = this.moment("2015-01-01")
              .startOf("day")
              .seconds(this.segundos)
              .format("mm:ss");
            this.segundosLabel =
              "Você tem " +
              segundosFormatados +
              " para completar essa etapa do fluxo";
            this.segundos--;
            this.timer();
          } else {
            this.logout();
          }
        }, 1000);
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      if (!year || !month || !day) return date;

      var dataFormatada = `${day}/${month}/${year}`;

      return dataFormatada;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");

      if (!year || !month || !day) return date;

      var dataParseada = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;

      return dataParseada;
    },
    async gravaDadosPessoais() {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });

      try {
        if (this.pessoa.rg && !this.pessoa.dtEmissaoRg) {
          this.erroMensagemEmissaoRG = "Preencha a data de emissão do RG";
          this.$refs.formPessoa.validate();
          return;
        } else {
          this.erroMensagemEmissaoRG = null;
        }

        if (this.$refs.formPessoa.validate()) {
          if (this.pessoa.codCargoPretendido != 0) {
            const found = this.cargos.find(
              (element) => element.codCargo == this.pessoa.codCargoPretendido
            );
            this.pessoa.cargoPretendido = found.descricao;
          }
          //TODO

          // Faz uma Deep Copy para que as formatações de datas (necessário para a requisição), fiquem apenas no escopo da função.
          // E não leve as datas no formato YYYY-MM-DD para os inputs, pois se levar a mascara será aplicada e irá invalidar as datas.
          let p = JSON.parse(JSON.stringify(this.pessoa));
          p.dtnascimento = this.parseDate(p.dtnascimento);
          p.dtEmissaoRg = this.parseDate(p.dtEmissaoRg);
          p.dtValidadeCNH = this.parseDate(p.dtValidadeCNH);

          p.celular = p.celular === null ? 0 : p.celular;
          p.fone = p.fone === null ? 0 : p.fone;

          // Normaliza as string, para remover caracteres especiais.
          p.nome = p.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          p.email = p.email.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          p.endereco = p.endereco
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          p.bairro = p.bairro.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          p.cidade = p.cidade.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          p.vlrSalPretendido = parseFloat(
            p.vlrSalPretendido.replace(/[^0-9,]*/g, "").replace(",", ".")
          ).toFixed(2);

          // Tenta recuperar codPessoa do Storage... caso for 0 é um novo registro
          p.codpessoa =
            localStorage.getItem("codPessoa") !== null
              ? parseInt(localStorage.getItem("codPessoa"))
              : 0;

          // Faz o objeto pessoa receber algumas string que eventualmente podem ter sido alterada pela função que normaliza e remove caracteres especiais.
          this.pessoa.nome = p.nome;
          this.pessoa.email = p.email;
          this.pessoa.endereco = p.endereco;
          this.pessoa.bairro = p.bairro;
          this.pessoa.cidade = p.cidade;
          this.pessoa.codpessoa = p.codpessoa;
          this.pessoa.vlrSalPretendido = formatter.format(p.vlrSalPretendido);

          this.loading = true;
          var response = await this.service.gravaDadosPessoais(p);

          if (response.data.retorno[0].estatus === "Sucesso") {
            const [, codPessoa, codCandidato] =
              response?.data?.retorno?.[0]?.msgErro.split("-") ?? [
                null,
                0,
                0,
                null,
              ];
            localStorage.setItem("codCandidato", parseInt(codCandidato));
            localStorage.setItem("codPessoa", parseInt(codPessoa));

            this.e6 = 2;
            this.resetarTimer();

            const responsePDF = await this.service.getPDFLgpd();
            if (responsePDF.status === 200) {
              const responseLGPD = await this.service.buscaObsLGPD(
                parseInt(codPessoa)
              );

              if (responseLGPD.data.retorno[0].estatus !== "Sucesso") {
                const idRetorno =
                  responseLGPD.data.retorno[0].msgErro.split(" -")[0];

                if (idRetorno === "2") {
                  this.urltermo = this.service.getUrlTermo();
                  this.dialogLGPD = true;
                }
              }
            }
          } else {
            this.dialog = false;
            this.mensagem = response.data.retorno[0].msgErro;
            this.snackbarColor = "red";
            this.snackbar = true;
            this.loading = false;
          }
        }
      } catch (e) {
        var erros = e.map(function (erro) {
          return erro["erro"] + " \n";
        });

        if (!erros) {
          erros =
            "Não foi possível continuar com seu cadastro, verique as informações inseridas e tente novamente.";
        }

        this.mensagem = erros.toString();
        this.snackbar = true;
        this.loading = false;
      }
      /*       finally {
        this.e6 = 2;
        this.resetarTimer();
      } */
    },
    async gravaAreasInteresse() {
      if (this.$refs.formAreaInteresse.validate()) {
        for (let area of this.areas) {
          area.codcandidato = localStorage.getItem("codCandidato");
        }
        await this.service.gravaAreasInteresse(this.areas);
        this.e6 = 3;
        this.resetarTimer();
      }
    },
    async gravaFormacaoAcademica() {
      if (this.$refs.formFormacaoAcademica.validate()) {
        for (let formacao of this.formacoes) {
          formacao.codpessoa = parseInt(localStorage.getItem("codPessoa"));
          formacao.dtConclusao = this.parseDate(formacao.dtConclusao);
        }
        await this.service.gravaFormacaoAcademica(this.formacoes);

        for (let formacao of this.formacoes) {
          formacao.codpessoa = parseInt(localStorage.getItem("codPessoa"));
          formacao.dtConclusao = this.formatDate(formacao.dtConclusao);
        }
        this.e6 = 4;
        this.resetarTimer();
      }
    },
    async gravaHistoricoProfissional() {
      if (this.$refs.formProfissional.validate()) {
        // Faz uma Deep Copy para que as formatações de datas (necessário para a requisição), fiquem apenas no escopo da função.
        // E não leve as datas no formato YYYY-MM-DD para os inputs, pois se levar a mascara será aplicada e irá invalidar as datas.
        let hist = JSON.parse(JSON.stringify(this.historicos));

        for (let historico of hist) {
          historico.codpessoa = parseInt(localStorage.getItem("codPessoa"));
          historico.dtEntrada = this.parseDate(historico.dtEntrada);
          historico.dtSaida = this.parseDate(historico.dtSaida);
          historico.salarioInicial = parseFloat(
            historico.salarioInicial.replace(/[^0-9,]*/g, "").replace(",", ".")
          ).toFixed(2);
          historico.salarioFinal = parseFloat(
            historico.salarioFinal.replace(/[^0-9,]*/g, "").replace(",", ".")
          ).toFixed(2);
        }

        var response = await this.service.gravaHistoricoProfissional(hist);

        if (response.data.retorno) {
          if (response.data.retorno[0].estatus === "Sucesso") {
            this.e6 = 5;
            this.resetarTimer();

            // Currículo não atualiza os dados profissionais e não adiciona novos.
            // Apenas aceita cadastrar registros se ainda não tiver nada em dados profissionais,
            // Depois de ter algo cadastrado, sempre retorna 200 e ok, só da erro se tentar alterar o nome da empresa, os demais dados não altera e mesmo assim retorna 200
          } else {
            this.dialogErro = true;
            this.dialogMessage =
              "Não foi possível atualizar as informações profissionais.";
          }
        } else {
          if (response.data.logErroApp) {
            this.dialogErro = true;
            this.dialogMessage =
              "Não foi possível atualizar as informações profissionais. \n " +
              "Erro : " +
              response.data.logErroApp[0].erro;
          } else {
            this.dialogErro = true;
            this.dialogMessage =
              "Não foi possível atualizar as informações profissionais.";
          }
        }
      }
    },
    async gravaPessoaReferencia() {
      for (let i of this.indicacoes) {
        i.codCandidato = parseInt(localStorage.getItem("codCandidato"));
      }
      await this.service.gravaPessoaReferencia(this.indicacoes);
      this.e6 = 6;
      this.resetarTimer();
    },
    async gravaIdioma() {
      for (let i of this.idiomas) {
        i.codpessoa = parseInt(localStorage.getItem("codPessoa"));
      }
      await this.service.gravaIdioma(this.idiomas);
      this.e6 = 7;
      this.resetarTimer();
    },
    async gravaAnexo() {
      this.erroExtensao = false
      this.uploadArquivos.forEach(async arquivo => {
        if (arquivo.valor) {
          await this.realizaUpload(arquivo.valor, arquivo.tabela, arquivo.campo, arquivo.titulo)
        }
      });

      if (this.erroExtensao === false){
        this.e6 = 8;
        this.resetarTimer();
      }
      else {
        this.dialogErro = true
        this.dialogMessage = `So é possivel anexar imagem com extensão JPG, JPEG e PNG!`
        return;
      }
    },

    async realizaUpload(arquivoUpload, tabela, campo, titulo = null) {
      if (!arquivoUpload) {
        return;
      }

      if (campo === 'imagem' && arquivoUpload.name != ''){
        let ext = arquivoUpload.name.split('.').pop();
        if (ext.toUpperCase() != 'JPG' && ext.toUpperCase() != 'JPEG' && ext.toUpperCase() != 'PNG'){
          this.erroExtensao = true
        }
      }
   
      const response = await this.service.uploadArquivo(arquivoUpload, tabela, campo);

      if (response.status != 200) {
        this.dialogErro = true;
        this.dialogMessage = `Não foi possível anexar o campo ${titulo}!`;
      }
    },

    moment: function () {
      return moment();
    },
    async aceitar() {
      const codPessoa = localStorage.getItem("codPessoa");
      const response = await this.service.gravaObs(parseInt(codPessoa));

      if (response.data.retorno[0].estatus === "Sucesso") {
        this.dialogLGPD = false;
        return;
      }

      this.dialogErro = true;
      this.dialogMessage =
        "Não foi possível atualizar os termos de uso. \n " +
        "Erro : " +
        response.data.logErroApp[0].erro;
    },
    async getCidadeCEP() {
      var response = await this.service.getCidadeCEP(this.pessoa.codcep);
      if (
        response.data.localidade !== null &&
        response.data.localidade !== "" &&
        response.data.localidade !== undefined
      ) {
        if (!this.pessoa.bairro) {
          this.pessoa.bairro = response.data.bairro;
        }

        if (!this.pessoa.codcep) {
          this.pessoa.codcep = response.data.cep;
        }

        this.pessoa.uf = response.data.uf;
        this.pessoa.cidade = response.data.localidade;

        if (!this.pessoa.endereco) {
          this.pessoa.endereco = response.data.logradouro;
        }
        this.pessoa.codibge = response.data.ibge;
      } else {
        this.pessoa.bairro = "";
        this.pessoa.codcep = "";
        this.pessoa.uf = "";
        this.pessoa.cidade = "";
        this.pessoa.endereco = "";
        this.pessoa.codibge = 0;
      }
    },
    async alteraSenha() {
      var response = await this.service.alteraSenha(this.pessoa.senha);
      if (response.data.retorno[0].estatus === "Sucesso") {
        localStorage.setItem("senha", this.pessoa.senha);
        this.dialog = false;
        this.mensagem = "Senha alterada com sucesso!";
        this.snackbarColor = "green";
        this.snackbar = true;
      } else {
        this.dialog = false;
        this.mensagem = "Não foi possível alterar a senha!";
        this.snackbarColor = "red";
        this.snackbar = true;
      }
    },
    addFormacao() {
      this.formacoes.push({
        codEducacao: 0,
        habilitacao: "",
        instituicao: "",
        dtConclusao: "",
        codpessoa: 0,
      });
    },
    addArea() {
      this.areas.push({
        codcandidato: null,
        codAreaInteresse: null,
        descricao: null,
      });
    },
    addHistorico() {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });

      const isEmpty = Object.values(
        this.historicos[this.historicos.length - 1]
      ).every((x) => x === null || x === "");

      // Somente adicionar mais um item no histórico profissional se o form validar e se o último item não estiver completamente vazio.

      if (this.$refs.formProfissional.validate() || !isEmpty) {
        this.historicos.push({
          codpessoa: null,
          empresaAnterior: null,
          cargoInicial: null,
          cargoFinal: null,
          salarioInicial: formatter.format("0.00"),
          salarioFinal: formatter.format("0.00"),
          dtEntrada: null,
          dtSaida: null,
          atribuicoes: null,
          motivosaida: null,
        });
      }
    },
    addPessoa() {
      this.indicacoes.push({
        codPessoa: null,
        nome: null,
        telefone: null,
        vip: false,
      });
    },
    addIdioma() {
      this.idiomas.push({
        codPessoa: 0,
        codidioma: 0,
        le: false,
        fala: false,
        escreve: false,
      });
    },
    logout() {
      localStorage.removeItem("codPessoa");
      localStorage.removeItem("codCandidato");
      localStorage.removeItem("cpf");
      localStorage.removeItem("senha");
      localStorage.removeItem("logado");
      this.$emit("home", LoginVue);
    },
    vagas() {
      this.$emit("home", VagasEmpregoVue);
    },
    resetarTimer() {
      this.segundos = parseInt(this.$segundosSessao);
      this.loading = false;
    },
    validacaoDataAtual(data) {
      let dataNascimento = new Date(this.parseDate(data));
      let hoje = new Date();

      // Se a data de nascimento for maior que a data atual não valida
      if (dataNascimento > hoje) {
        return false;
      } else {
        return true;
      }
    },
    dataValida(data) {
      if (data) {
        var dataFormatoPadrao = this.parseDate(data); //YYYY-MM-DD
        return moment(dataFormatoPadrao).isValid();
      } else {
        return true;
      }
    },
    validaCNH(valor) {
      if (this.pessoa.cnh && !(this.pessoa.codpessoa > 0)) {
        if (valor) {
          return true;
        }
        return false;
      }
      return true;
    },
    validaRG(valor) {
      if (this.$obrigaRG) {
        return !!valor;
      }
      return true;
    },
    validaCelular(valor) {
      if (this.$obrigaCelular) {
        return !!valor;
      }
      return true;
    },
    validaEmail(valor) {
      if (this.$obrigaEmail) {
        return !!valor;
      }
      return true;
    },
    validaPretensao(valor){
      let valorNovo = valor.replace('R$','')
      valorNovo = parseFloat(valorNovo)
      if (this.$pretensaoSalarialObrigatoria) {
        if (valorNovo === 0){
          return ''
        }
      }
      return true;
    },
    validaObrigatorioCNH(valor) {
      if (this.$obrigaCNH) {
        return !!valor;
      }
      return true;
    },
    validaHistoricoEmpresa(valor){
      this.empresaAnteriorValida = valor;
      if (this.parametros.length > 0) {
        if (this.parametros[0].pedeHistProfissional === true){
          if (valor === "" || valor === null){
            return false
          }
          else 
            return true
        }
        else
          return true
      }
    },
    validaHistorico(valor){
      if (this.parametros.length > 0) {
        if (this.parametros[0].pedeHistProfissional === true || this.empresaAnteriorValida != "" && this.empresaAnteriorValida != null){
          if (valor === "" || valor === null){
            return false
          }
          else 
            return true
        }
        else
          return true
      }
    },
    validaArea(valor){
      if (this.$obrigaAreaInteresse) {
          if (this.areas[0].codAreaInteresse === null){
            return !!valor;
          }
      }
      return true;
    },
    validaFormacao(valor){
      const instrucaoSelecionada = this.instrucoes.find( grau => grau.codGrau === this.pessoa.codgrau );
      if (instrucaoSelecionada.codGrauRais > 7 && this.formacoes[0].codEducacao === null){
            return !!valor;
      }
      return true;
    }
  },
  computed: {
    uploadArquivos() {
      const arrayUploads = [
        {
          valor: this.imagem,
          campo: 'imagem',
          titulo: 'Imagem',
          tabela: 'pessoa'
        },
        {
          valor: this.arquivoCurriculo,
          campo: 'curriculoArquivo',
          titulo: 'Currículo (Arquivo)',
          tabela: 'candidato'
        },
      ]
      return arrayUploads
    }
  }
};
</script>
